module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-form-registration"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "space-20"
  }), _vm._v(" "), _c('form', {
    staticClass: "form-register",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doRegistration()
      }
    }
  }, [_c('input-text', {
    attrs: {
      "placeholder": "Como gostaria de ser chamado?",
      "name": "name",
      "error": _vm.errors.name
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('input-email', {
    attrs: {
      "placeholder": "E-mail",
      "name": "email",
      "error": _vm.errors.email
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input-password', {
    attrs: {
      "placeholder": "Senha",
      "name": "password",
      "error": _vm.errors.password
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input-password', {
    attrs: {
      "placeholder": "Confirme a senha",
      "name": "password_confirmation",
      "error": _vm.errors.password_confirmation
    },
    model: {
      value: (_vm.passwordConfirmation),
      callback: function($$v) {
        _vm.passwordConfirmation = $$v
      },
      expression: "passwordConfirmation"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "space-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.terms && !_vm.terms
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }],
    attrs: {
      "type": "checkbox",
      "name": "terms"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms) ? _vm._i(_vm.terms, null) > -1 : (_vm.terms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-15"
  }, [_vm._v("Lí e aceito")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'use_terms'
      },
      "target": "_blank"
    }
  }, [_vm._v("termos de uso")]), _vm._v(" e as\n              "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy_policy'
      },
      "target": "_blank"
    }
  }, [_vm._v("políticas de privacidade")]), _vm._v(".\n            ")], 1)]), _vm._v(" "), (_vm.errors.terms && !_vm.terms) ? _c('span', {
    staticClass: "help-block text-left",
    domProps: {
      "innerHTML": _vm._s(_vm.errors.terms)
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "space-15"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('button', {
    staticClass: "btn btn-success bold",
    attrs: {
      "disabled": _vm.loading,
      "type": "submit"
    }
  }, [_vm._v("\n        CADASTRAR\n        "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-fw fa-lg fa-spinner fa-spin"
  })]) : _vm._e()])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title title-form title-success text-center"
  }, [_c('strong', [_vm._v("CADASTRE-SE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aef7326a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/FormRegistration.vue
// module id = 320
// module chunks = 18